import * as React from "react";
import { NumberLessBRL } from "src/services"; 
import './ShareMonthlyEvolution.scss'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import DragHandleIcon from '@material-ui/icons/DragHandle'

interface IItemValueProps {
    value: any;
    share: any;  
    shareAnterior?: any;
}  

export default function ItemValue( props: IItemValueProps ) { 

    const {value, share, shareAnterior} = props
    const verifica = () => {
        const atual = share ? Number(share).toFixed(2).replace(/\./g, ',') : 0 
        const anterior = shareAnterior ? Number(shareAnterior).toFixed(2).replace(/\./g, ',') : 0 
        if (anterior === atual) {
            return <DragHandleIcon className="icone-igual"  fontSize={'18'}/>
        }
        return atual >= anterior ? <ArrowUpwardIcon color="primary" fontSize={'18'}/>: <ArrowDownwardIcon color="error" fontSize={'18'} />;
    }
    return (
        <div className="container_cell_table">
            <div className="box_item_value">
                <span>{NumberLessBRL(value.toString())}</span>
                <span>{share ? Number(share).toFixed(2).replace(/\./g, ',') + ' %' : ''}</span>
            </div> 
            {shareAnterior && verifica() }
        </div>   
           

    )
}


// WEBPACK FOOTER //
// ./src/component/publisher/sale/share-mothly-evolution/ItemValue.tsx